<script setup>
const { t } = useI18n()
</script>

<template>
  <div class="flex grow flex-col justify-end">
    <BaseLink url="/account/contact">
      <DSButton
        class="btn btn-md w-full truncate uppercase btn-fill-secondary"
      >
        {{ t('Contact Us') }}
      </DSButton>
    </BaseLink>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Contact Us": "Contact Us"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Contact Us": "Kontaktieren Sie uns"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Contact Us": "Nous contacter"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Contact Us": "Contactarnos"
}
</i18n>
